import { Action } from 'redux';
import { QueueDisplayScreen } from '../../../models/Entities/Turnero';
import { TurneroQueueDisplayScreenState, TurneroQueueDisplayScreenUnloadState } from '../../states/Turnero-QueueDisplayScreen.State';

export default function TurneroQueueDisplayScreenReducer(
    state: TurneroQueueDisplayScreenState | undefined,
    action: Action
): TurneroQueueDisplayScreenState {
    const currentState = state ?? TurneroQueueDisplayScreenUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_ALL_REQUEST':
            return {
                ...currentState,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_ALL_SUCCESS':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: a.payload || []
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_ALL_FAILURE':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: a.error
            } as TurneroQueueDisplayScreenState;

        case 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_BY_ID_REQUEST':
            return {
                ...currentState,
                isLoadingOne: true,
                isLoadingOneSuccess: false,
                FailGettingOne: false,
                error: undefined
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_BY_ID_SUCCESS': {
            const list = currentState.list || [];
            const exists = list.find((item: QueueDisplayScreen) => item.id === a.payload?.id);
            const nextList = exists
                ? list.map((item: QueueDisplayScreen) => (item.id === a.payload?.id ? a.payload : item))
                : [...list, a.payload];
            return {
                ...currentState,
                isLoadingOne: false,
                isLoadingOneSuccess: true,
                FailGettingOne: false,
                error: undefined,
                list: nextList
            } as TurneroQueueDisplayScreenState;
        }
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_BY_ID_FAILURE':
            return {
                ...currentState,
                isLoadingOne: false,
                isLoadingOneSuccess: false,
                FailGettingOne: true,
                error: a.error
            } as TurneroQueueDisplayScreenState;

        case 'TURNERO-QUEUE_DISPLAY_SCREEN_CREATE_REQUEST':
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_REGISTER_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_CREATE_SUCCESS':
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_REGISTER_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_CREATE_FAILURE':
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_REGISTER_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroQueueDisplayScreenState;

        case 'TURNERO-QUEUE_DISPLAY_SCREEN_UPDATE_REQUEST':
            return {
                ...currentState,
                isUpdatingOne: true,
                successUpdatingOne: false,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_UPDATE_SUCCESS':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_UPDATE_FAILURE':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: a.error
            } as TurneroQueueDisplayScreenState;

        case 'TURNERO-QUEUE_DISPLAY_SCREEN_DELETE_REQUEST':
            return {
                ...currentState,
                isDeletingOne: true,
                successDeletingOne: false,
                failOnDeletingOne: false,
                error: undefined
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_DELETE_SUCCESS':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                error: undefined,
                list: (currentState.list || []).filter((s: QueueDisplayScreen) => s.id !== a.payload)
            } as TurneroQueueDisplayScreenState;
        case 'TURNERO-QUEUE_DISPLAY_SCREEN_DELETE_FAILURE':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: a.error
            } as TurneroQueueDisplayScreenState;

        default:
            return currentState as TurneroQueueDisplayScreenState;
    }
}
